import { route } from "../globals/constants";
/**
  * 返回路由路径
*/
export  function getRoutePath(item) {
        const link = JSON.parse(item?.link);
        let path = ''
        switch(link?.action) {
            case 'portal':
                path = route.home.HOME1
                break;
            case 'aboutus':
                path = route.pages.ABOUT
                break;    
            case 'contactus':
                path = route.pages.contact.CONTACT1
                break;    
            case 'services':
                path = route.services.SERVICES
                break;  
            case 'goods':
                path = route.shop.PRODUCTS
                break;    
            case 'good':
                path = `${route.shop.DETAIL}/${link.param.id}`
                break;    
            case 'url' :
                path = link.param.url
                break;
            case 'page':
                path = `${route.pages.PAGE}/${link.param.id}`         
        }

        return path;
    }

export function renderContactInfo(content) {
       
    if(content?.indexOf('#') > 0) {
        const texts = content?.split('#')
        return <div
            style={{
                display:'flex',
                flexDirection:'column'
            }}
        >
            {
                texts && texts.length > 0 && texts.map((text,index) => {
                    return <span key={`text-${index}`}>
                        {`${text} `}
                    </span>
                })
            }
        </div>
    }

    return <span>{content}</span>
}    


export function parseTitle(title) {
    const arr = title?.split(' ')
    let one = ''
    let two = ''
    let three = ''
    if( arr.length == 1 ) {
        one = title
        two = ''
        three = ''
    }
    else if(arr.length === 2) {
        one = arr[0]
        two = arr[1]
        three = ''
    } else if(arr.length > 2) {
        one = arr[0]
        two = arr[1]
        three =  arr.slice(2).join(' ')
    }


    return {
        one, 
        two, 
        three
    }
}